import { Component, OnInit } from "@angular/core";
import { LanguageService } from "./services/language.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  public constructor(private languageService: LanguageService) {
    this.languageService.init();
  }

  public async ngOnInit() {}
}
